import React, { Dispatch, SetStateAction } from "react";
import LanguageSwitchInline from "./LanguageSwitchInline";
import LanguageSwitchHamburger from "./LanguageSwitchHamburger";
import { Language } from "./Languages";

function LanguageSwitch(
  props: Readonly<{
    setIsAllMenuOpen: Dispatch<SetStateAction<boolean>>;
    isAllMenuOpen: boolean;
    isInline: boolean;
    languages?: Language[];
    className?: string;
  }>
) {
  // Use the appropriate component based on the context
  if (props.isInline) {
    // Desktop inline dropdown
    return (
      <LanguageSwitchInline 
        languages={props.languages} 
        className={props.className} 
      />
    );
  } else {
    // Mobile hamburger menu
    return (
      <LanguageSwitchHamburger 
        setIsAllMenuOpen={props.setIsAllMenuOpen}
        languages={props.languages} 
      />
    );
  }
}

export default LanguageSwitch;
